import {useFarm} from 'context/farmContext';
import {Form, Formik} from 'formik';
import Header from 'modules/header/farm/main';
import {useState} from 'react';
import {QualifyFormSchema} from './utilities/validationSchema';
import {qualifyInitialValues} from './utilities/initialValues';
import {useNavigate} from 'react-router-dom';
import QualityFormComponent from 'components/forms/quality';
import {existingUnits} from 'utilities/helper/existingUnitsOption';

const QualityForm = () => {
  const {uploadQualifyPage, farm} = useFarm();
  const [images, setImages] = useState<IUploadImage[]>(
    farm?.images ? farm.images : [],
  );
  const navigate = useNavigate();
  return (
    <>
      <Header title=" ثبت آگهی" />
      <Formik
        initialValues={qualifyInitialValues(farm)}
        validationSchema={QualifyFormSchema}
        onSubmit={values => {
          const qualifyData = {
            images,
            existing_unit: values.existing_unit,
            existing: values.existing,
          };
          uploadQualifyPage(qualifyData);
          navigate('/farm/add-ad/owner');
        }}
      >
        <Form className="pb-[7vh]">
          <QualityFormComponent
            images={images}
            setImages={setImages}
            existingUnits={existingUnits}
          />
        </Form>
      </Formik>
    </>
  );
};

export default QualityForm;
